(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
  // Collapsible functionality
  const collapsibleTriggers = document.querySelectorAll('.collapsible-trigger');
  
  collapsibleTriggers.forEach(trigger => {
    // Set initial state
    const isOpen = trigger.classList.contains('is-open');
    trigger.setAttribute('aria-expanded', isOpen);
    
    // Add click event
    trigger.addEventListener('click', toggleCollapsible);
  });
  
  function toggleCollapsible(e) {
    const trigger = e.currentTarget;
    const isOpen = trigger.classList.contains('is-open');
    const moduleId = trigger.getAttribute('aria-controls');
    const container = document.getElementById(moduleId);
    
    if (!container) return;
    
    const contentInner = container.querySelector('.collapsible-content__inner');
    const isAutoHeight = container.classList.contains('collapsible--auto-height');
    
    // Toggle aria-expanded
    trigger.setAttribute('aria-expanded', !isOpen);
    
    // Toggle classes
    if (isOpen) {
      trigger.classList.remove('is-open');
      container.classList.remove('is-open');
      
      // If auto-height, set height to 0 for closing animation
      if (isAutoHeight) {
        container.style.height = contentInner.offsetHeight + 'px';
        // Force reflow
        container.offsetHeight;
        container.style.height = '0px';
      } else {
        container.style.height = '0px';
      }
    } else {
      trigger.classList.add('is-open');
      container.classList.add('is-open');
      
      // If auto-height, set to actual height then auto
      if (isAutoHeight) {
        container.style.height = contentInner.offsetHeight + 'px';
        setTimeout(() => {
          container.style.height = 'auto';
        }, 300);
      } else {
        container.style.height = contentInner.offsetHeight + 'px';
      }
    }
    
    // Add transition end listener for auto-height containers
    if (isAutoHeight) {
      const handleTransitionEnd = () => {
        if (container.classList.contains('is-open')) {
          container.style.height = 'auto';
        }
        container.removeEventListener('transitionend', handleTransitionEnd);
      };
      
      container.addEventListener('transitionend', handleTransitionEnd);
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["impu-faq"] && !Shopify.designMode) return;
  try {
    

(function () {

  function initFAQ() {

    /* =========================================
       FAQ SECTION CLICK HANDLER
       ========================================= */

    document.addEventListener('click', function (event) {

      const trigger = event.target.closest(
        '[data-faq-trigger]'
      );

      /* Not an FAQ button */
      if (!trigger) {
        return;
      }

      /* Make sure this trigger belongs
         to our FAQ section */
      const faqSection = trigger.closest(
        '[id^="faqsection-"]'
      );

      if (!faqSection) {
        return;
      }

      /* Prevent any theme/default action */
      event.preventDefault();


      /* =========================================
         FIND CONTENT
         ========================================= */

      const contentId =
        trigger.getAttribute('aria-controls');

      if (!contentId) {
        return;
      }

      const content =
        document.getElementById(contentId);

      if (!content) {
        return;
      }


      const answer =
        content.querySelector(
          '.faq-section__answer'
        );

      if (!answer) {
        return;
      }


      /* =========================================
         CHECK CURRENT STATE
         ========================================= */

      const isOpen =
        trigger.classList.contains('is-open');


      /* =========================================
         CLOSE
         ========================================= */

      if (isOpen) {

        trigger.classList.remove(
          'is-open'
        );

        trigger.setAttribute(
          'aria-expanded',
          'false'
        );

        content.setAttribute(
          'aria-hidden',
          'true'
        );


        /* Set current height first */
        content.style.height =
          content.scrollHeight + 'px';


        /* Force reflow */
        content.offsetHeight;


        /* Animate to zero */
        requestAnimationFrame(function () {

          content.style.height = '0px';

        });


        return;
      }


      /* =========================================
         OPEN
         ========================================= */

      trigger.classList.add(
        'is-open'
      );

      trigger.setAttribute(
        'aria-expanded',
        'true'
      );

      content.setAttribute(
        'aria-hidden',
        'false'
      );

      content.classList.add(
        'is-open'
      );


      /* Start from zero */
      content.style.height = '0px';


      /* Force reflow */
      content.offsetHeight;


      /* Get actual answer height */
      const height =
        answer.scrollHeight;


      /* Animate open */
      requestAnimationFrame(function () {

        content.style.height =
          height + 'px';

      });


      /* After animation use auto */
      const onTransitionEnd =
        function (e) {

          if (
            e.propertyName !== 'height'
          ) {
            return;
          }

          if (
            content.classList.contains(
              'is-open'
            )
          ) {

            content.style.height =
              'auto';

          }

          content.removeEventListener(
            'transitionend',
            onTransitionEnd
          );

        };


      content.addEventListener(
        'transitionend',
        onTransitionEnd
      );

    });


    /* =========================================
       SHOPIFY THEME EDITOR
       ========================================= */

    document.addEventListener(
      'shopify:section:load',
      function (event) {

        const section =
          event.target.querySelector(
            '[id^="faqsection-"]'
          );

        if (!section) {
          return;
        }

        /* Reset all FAQ items */

        const triggers =
          section.querySelectorAll(
            '[data-faq-trigger]'
          );

        triggers.forEach(function (trigger) {

          const contentId =
            trigger.getAttribute(
              'aria-controls'
            );

          const content =
            document.getElementById(
              contentId
            );

          if (!content) {
            return;
          }

          trigger.classList.remove(
            'is-open'
          );

          trigger.setAttribute(
            'aria-expanded',
            'false'
          );

          content.classList.remove(
            'is-open'
          );

          content.setAttribute(
            'aria-hidden',
            'true'
          );

          content.style.height =
            '0px';

        });

      }
    );


  }


  /* =========================================
     INITIALIZE
     ========================================= */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initFAQ
    );

  } else {

    initFAQ();

  }

})();


  } catch(e) { console.error(e); }
})();
})();
